import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      width: 18px;\n      height: 18px;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    width: 24px;\n    height: 24px;\n    ", "\n    path {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      width: 14px;\n      height: 13px;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    width: 40px;\n    height: 36px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 56px;\n  width: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.4s;\n  opacity: 1;\n  position: relative;\n  ", "\n  svg {\n    width: 18px;\n    height: 17px;\n    ", "\n    path {\n      fill: ", ";\n    }\n  }\n  &:disabled {\n    opacity: 0.4;\n  }\n  &:hover {\n    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);\n  }\n  &:not(:first-child) {\n    &::before {\n      content: \"\";\n      display: block;\n      width: 1px;\n      top: 10px;\n      bottom: 10px;\n      background-color: #ecedee;\n      left: -0.5px;\n      position: absolute;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: #ffffff;\n  border-radius: 6px;\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import { baseFontColor } from "@temp/@next/globalStyles/constants";
export var Wrapper = styled.div(_templateObject());
export var Button = styled.button(_templateObject2(), media.xxLargeScreen(_templateObject3()), media.xxLargeScreen(_templateObject4()), function (props) {
  return props.filled ? baseFontColor : "none";
});
export var ShareButton = styled(Button)(_templateObject5(), media.xxLargeScreen(_templateObject6()), baseFontColor);